import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Row } from "reactstrap";
import { useTranslate } from "hooks";
import { ProductBreadcrumb } from "components/_ProductConfigurator/Breadcrumb/ProductBreadcrumb";
import s from "./ProductsOverview.module.scss";
import { ProductsOverviewSearch } from "./ProductsOverviewSearch";

export const ProductsOverviewHeader = Scrivito.connect(
  ({ isModalActive, title, infoText, handleBackAction, ...rest }) => {
    const translate = useTranslate();

    return (
      <Row
        className={cx(s.headerProducts, "p-5 pb-0 sticky-top bg-gray-100 z-1", {
          "px-3": infoText,
          "bg-white": isModalActive,
        })}
      >
        <div
          className={cx("d-flex justify-content-between", s.headerFirstLine)}
        >
          <h3 className="text-uppercase">{title}</h3>

          {!infoText && (
            <ProductsOverviewSearch
              isModalActive={isModalActive}
              infoText={infoText}
              handleBackAction={handleBackAction}
              {...rest}
            />
          )}
        </div>

        {isModalActive && <h4>{translate("WIZARD_PRODUCT_SERIES")}</h4>}
        {!isModalActive && <ProductBreadcrumb />}
      </Row>
    );
  },
);
